// The "Your week ahead" figures, worked out from the teacher's own upcoming
// workshops. Days are compared on the venue's wall clock, the same day the
// calendar files a workshop under.

import { format } from 'date-fns';

import { formatVenueDate, formatVenueTime } from '../../../utils/venueTime';
import type { WorkshopChip } from '../primitives';

const DAY_KEY = 'yyyy-MM-dd';

function dayOf(w: WorkshopChip): string {
  return formatVenueDate(w.localDate ?? w.date, DAY_KEY, '');
}

export function isToday(w: WorkshopChip, now: Date): boolean {
  return dayOf(w) === format(now, DAY_KEY);
}

/** Workshops from today through Saturday, the last day of the calendar week. */
export function remainingThisWeek(workshops: WorkshopChip[], now: Date): number {
  const saturday = new Date(now);
  saturday.setDate(now.getDate() + (6 - now.getDay()));
  const today = format(now, DAY_KEY);
  const last = format(saturday, DAY_KEY);
  return workshops.filter((w) => dayOf(w) >= today && dayOf(w) <= last).length;
}

/** "Today 6:30 PM", or "Thu, May 21 · 7:00 PM" for a later day. */
export function nextShiftLabel(w: WorkshopChip | undefined, now: Date): string {
  if (!w) return '—';
  const time = formatVenueTime(w.localDate ?? w.date);
  return isToday(w, now) ? `Today ${time}` : `${formatVenueDate(w.localDate ?? w.date)} · ${time}`;
}

/** One tree per seat, so the prep is the capacity in the workshop's species. */
export function prepLabel(w: WorkshopChip | undefined): string {
  if (!w) return '—';
  return w.species ? `${w.capacity} ${w.species}` : `${w.capacity} trees`;
}
